module.exports = __webpack_public_path__ + "static/media/banner_oquefalam_01.cc465c5a.png";